"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 47.17 24",
    width: "47.17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m46.42 0h-31.73a.82.82 0 0 0 -.82.73v17.53h-13.08a.79.79 0 1 0 0 1.58h17.28a1.9 1.9 0 0 0 0 .25 3.91 3.91 0 0 0 7.82 0c0-.09 0-.17 0-.26h6.71a2.3 2.3 0 0 0 0 .26 3.91 3.91 0 0 0 7.82 0c0-.09 0-.17 0-.25h6.05a.76.76 0 0 0 .75-.75v-18.35a.75.75 0 0 0 -.8-.74zm-22.12 20.09a2.35 2.35 0 1 1 -2.3-2.36 2.35 2.35 0 0 1 2.3 2.36zm14.54 0a2.36 2.36 0 1 1 -2.36-2.36 2.36 2.36 0 0 1 2.36 2.36zm6.84-1.83h-5.76a3.88 3.88 0 0 0 -6.88 0h-.09-7.56a3.88 3.88 0 0 0 -6.88 0h-3.07v-16.78h30.24z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m25.19 4.53h10.96v10.96h-10.96z"
  }));
};

exports["default"] = _default;